// insights
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const connectionString = process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

const realAppInsights = connectionString
	? new ApplicationInsights({
			config: {
				connectionString,
				enableAutoRouteTracking: true,
				enableRequestHeaderTracking: true,
				enableResponseHeaderTracking: true,
				enableAjaxPerfTracking: true,
				distributedTracingMode: 2, // Enable W3C distributed tracing
			},
		})
	: null;

if (realAppInsights) {
	realAppInsights.loadAppInsights();
	realAppInsights.trackPageView();
	console.log('Application Insights initialized successfully');
} else {
	console.log('Application Insights disabled (no REACT_APP_APPINSIGHTS_CONNECTION_STRING)');
}

// No-op stub so call sites don't have to null-check every method.
const noopAppInsights = new Proxy({} as ApplicationInsights, {
	get: () => () => undefined,
});

const appInsights: ApplicationInsights = realAppInsights ?? noopAppInsights;

const trackEvent = (eventName: any, properties = {}) => {
	if (realAppInsights) {
		realAppInsights.trackEvent({ name: eventName, properties });
	} else {
		console.log('Telemetry disabled. Would have tracked:', eventName, properties);
	}
};

export { appInsights, trackEvent };
